import Icon from './ui/Icon';
import Reveal from './ui/Reveal';
import { site } from '../data/content';

export default function Contact() {
  return (
    <section className="alt tight" id="contact">
      <div className="wrap">
        <Reveal className="contact">
          <div className="ic">
            <Icon name="chat" />
          </div>
          <h2 className="h-sub">Got questions?</h2>
          <p>
            Still not sure or just want to chat? You can contact our team anytime by emailing{' '}
            <a className="mail" href={`mailto:${site.supportEmail}`}>
              {site.supportEmail}
            </a>
            . If you have any questions about the program or need a hand with anything else,
            we&rsquo;re just an email away. Drop us a line and we&rsquo;ll do our best to help.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
